// lillesol & pelle – Warenkorb-Helfer: mehrere Positionen hinzufügen und Slide-Cart öffnen
window.lpAddToCart = async function (items, btn) {
  if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '…'; }
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer-section' }) });
    const j = await r.json();
    if (!r.ok) { alert(j.description || j.message || 'Konnte nicht in den Warenkorb legen.'); return false; }
    const html = j.sections && j.sections['cart-drawer-section'];
    const drawer = document.querySelector('#cart-drawer');
    if (html && drawer) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.cart-drawer__inner'); const cur = drawer.querySelector('.cart-drawer__inner');
      if (fresh && cur) cur.replaceWith(fresh);
      // Warenkorb-Icon aktualisieren
      const c = await fetch('/cart.js').then(x => x.json()).catch(() => null);
      if (c) document.querySelectorAll('.cart-bubble__text, [data-cart-count]').forEach(el => el.textContent = c.item_count);
      if (typeof drawer.open === 'function') drawer.open(); else if (typeof drawer.showDialog === 'function') drawer.showDialog();
      else location.href = '/cart';
    } else location.href = '/cart';
    return true;
  } finally { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } }
};

// ---- Strickset-Wächter: Gratis-Anleitung (Typ "Strickanleitung") nur zusammen mit ihrem Garn ----
(() => {
  let busy = false;
  const toast = msg => {
    let t = document.getElementById('lp-toast');
    if (!t) { t = document.createElement('div'); t.id = 'lp-toast';
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#3b3b3b;color:#fff;padding:12px 18px;border-radius:3px;font-size:.9rem;z-index:99999;max-width:90vw;box-shadow:0 2px 10px rgba(0,0,0,.2)';
      document.body.appendChild(t); }
    t.textContent = msg; t.style.display = 'block'; clearTimeout(t._h); t._h = setTimeout(() => t.style.display = 'none', 6000);
  };
  const refreshDrawer = async () => {
    const drawer = document.querySelector('#cart-drawer');
    try {
      const html = await fetch(location.pathname + '?sections=cart-drawer-section').then(r => r.json());
      const doc = new DOMParser().parseFromString(html['cart-drawer-section'], 'text/html');
      const fresh = doc.querySelector('.cart-drawer__inner'); const cur = drawer && drawer.querySelector('.cart-drawer__inner');
      if (fresh && cur) cur.replaceWith(fresh);
    } catch (e) {}
    const c = await fetch('/cart.js').then(r => r.json()).catch(() => null);
    if (c) document.querySelectorAll('.cart-bubble__text, [data-cart-count]').forEach(el => el.textContent = c.item_count);
  };
  window.lpCheckSets = async () => {
    if (busy) return; busy = true;
    try {
      const cart = await _origFetch('/cart.js').then(r => r.json());
      const garnSets = new Set(cart.items.filter(i => i.product_type === 'Garn').map(i => (i.properties || {})._set).filter(Boolean));
      const anyGarn = cart.items.some(i => i.product_type === 'Garn');
      const orphans = cart.items.filter(i => i.product_type === 'Strickanleitung' && i.final_price === 0 &&
        ((i.properties || {})._set ? !garnSets.has(i.properties._set) : !anyGarn));
      if (!orphans.length) return;
      const updates = {}; orphans.forEach(o => updates[o.key] = 0);
      await _origFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      toast('Die Anleitung „' + orphans[0].product_title.split('♥')[0].trim() + '“ gibt es nur zusammen mit dem Garn – wir haben sie deshalb entfernt.');
      if (location.pathname.startsWith('/cart')) location.reload(); else await refreshDrawer();
    } finally { busy = false; }
  };
  const _origFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await _origFetch(...args);
    try { const u = String(args[0] && args[0].url || args[0]);
      if (/\/cart\/(change|update|add|clear)/.test(u) && !busy) setTimeout(window.lpCheckSets, 400); } catch (e) {}
    return res;
  };
  document.addEventListener('DOMContentLoaded', () => setTimeout(window.lpCheckSets, 800));
})();

// ---- Passende Stoffe: Schnellansicht im Modalfenster statt Seitenwechsel ----
(() => {
  let dlg;
  const ensure = () => {
    if (dlg) return dlg;
    dlg = document.createElement('dialog'); dlg.className = 'lpq-dialog'; dlg.setAttribute('aria-label', 'Stoff-Schnellansicht');
    dlg.innerHTML = '<button type="button" class="lpq-dialog__close" aria-label="Schließen">×</button><div class="lpq-dialog__body"></div>';
    dlg.querySelector('.lpq-dialog__close').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    document.body.appendChild(dlg);
    return dlg;
  };
  const wire = root => {
    const q = root.querySelector('[data-lpq]'); if (!q) return;
    const form = q.querySelector('[data-lpq-form]'), img = q.querySelector('[data-lpq-img]'), link = q.querySelector('[data-lpq-link]');
    const name = q.querySelector('[data-lpq-farbname]'), vid = q.querySelector('[data-lpq-variant]');
    q.querySelectorAll('.lpq__farbe').forEach(b => b.addEventListener('click', () => {
      q.querySelectorAll('.lpq__farbe').forEach(x => { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
      b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
      vid.value = b.dataset.variant; img.src = b.dataset.img; link.href = b.dataset.url; if (name) name.textContent = b.dataset.name;
    }));
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const it = { id: vid.value, quantity: parseInt(form.menge.value || 1) }; if (form.einheit) it.properties = { Einheit: form.einheit.value };
      const ok = await window.lpAddToCart([it], form.querySelector('button'));
      if (ok) dlg.close();
    });
  };
  window.lpQuick = async url => {
    const d = ensure(), body = d.querySelector('.lpq-dialog__body');
    body.innerHTML = '<div class="lpq-dialog__loading">Einen Moment …</div>';
    document.documentElement.style.overflow = 'hidden';
    d.showModal();
    try {
      const u = new URL(url, location.origin); u.searchParams.set('view', 'lp-quick');
      const r = await fetch(u.toString(), { credentials: 'same-origin' });
      if (!r.ok) throw new Error(r.status);
      body.innerHTML = await r.text(); wire(body);
    } catch (e) { location.href = url; }
  };
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-lpq-open]'); if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // Neuer Tab bleibt möglich
    e.preventDefault(); window.lpQuick(a.dataset.lpqOpen);
  });
})();
